import './pickup_delivery.less';
import './date_time_picker.less';

import React, {PropTypes} from 'react';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link, browserHistory} from 'react-router';
import shipmentActions from '../shipment/shipment_actions';
import CONSTANTS from '../common_constants';
import ShowError from '../components/error/show_error';
import DateTimePicker from 'react-datetime';
import moment from 'moment';
import validate from '../util/validate';
import classNames from 'classnames';
import $ from 'jquery';
import {toTitleCase,join,localTimestampToGMT,GMTTimeStampToLocal} from '../util/common';

const yesterday = DateTimePicker.moment().subtract( 1, 'day' );

class SetPickupAndDeliveyTime extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shipment: props.shipmentStatusData,
      carrierId: props.carrierId,
      shipmentInfo: props.shipmentInfo,
      showPickupTime: false,
      showDeliveryTime: false,
      editDeliveryTime: false,
      error: '',
      editPickupTime: false,
      disbleBtn: true
    }
    this.addEditPickUpDeliveryTime = this.addEditPickUpDeliveryTime.bind(this);
  }

  acceptOrDeclineOffer = (isAccept) => {
    const self = this;
    const {props,state} = this;
    const {shipmentActions} = props;
    const {shipmentId} = state.shipment;

    let paramObj = {
      shipmentId,
      carrierId: state.carrierId,
      isAccept
    }

    this.setState({isLoading: true});
    shipmentActions.acceptDeclineOffer(paramObj).then(() => {
      self.setState({isLoading: false, error: ''});
      props.updateErrorState('');
      if(!isAccept){
        browserHistory.push('/dashboard');
      }
      else{
        const {userData} = this.props.authState;
        if(userData.email) amplitude.getInstance().setUserId(userData.email);
        amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.REQ_ITEM_ACCEPT_OFFER);

        window.location.reload(true);
      }
    }, (errorRes) => {
      self.setState({isLoading: false, error: errorRes.error})
      props.updateErrorState(errorRes.error);
      $("html, body").animate({scrollTop: 0}, 1000);
    });
  }

  onPickupDateChange = (pickupDate) => {
    const date = pickupDate;
    const pickupTime = pickupDate.unix()*1000;
    this.setState({
      pickupDate:date,
      pickupTime,
      disbleBtn: false
    });
  }

  setDeliveryDate = () => {
    const self = this;
    const {props,state} = this;
    const {shipmentId} = state.shipment;
    const {deliveryTime,deliveryDate} = state;
    const {shipment,shipmentInfo} = this.state;

    // if(!deliveryTime && typeof(deliveryDate)!=="object") return this.setState({error: "Please set the pickup date"});
    let deliveryTimeParam;
    if( !deliveryTime && shipment.deliveryDateTime ){
     deliveryTimeParam = moment(shipment.deliveryDateTime).unix()*1000;
    }
    else deliveryTimeParam = deliveryTime;

    const paramObj = {
      shipmentId: shipmentId,
      isPickup: false,
      dateTime: deliveryTimeParam
    };

    this.setState({isLoading:true});

    props.shipmentActions.addEditPickUpDeliveryTime(paramObj).then(() => {
      self.setState({isLoading: false, error: '',editDeliveryTime: false,disbleBtn:false},props.updateErrorState(''));
      window.location.reload(true);
    }, (errorRes) => {
      self.setState({isLoading: false, error: errorRes.error})
      props.updateErrorState(errorRes.error);
      $("html, body").animate({scrollTop: 0}, 1000);
    });
  }

  addEditPickUpDeliveryTime = () => {

    if(this.state.disbleBtn) return false;

    if(this.state.shipmentInfo.shipmentType === 2) {
      return this.setDeliveryDate();
    }

    const {deliveryTime,pickupTime,pickupDate} = this.state;
    const self = this;
    const {props,state} = this;
    const {shipment} = this.state;
    const {shipmentId} = state.shipment;

    // if(!pickupTime && typeof(pickupDate)!=="object") return this.setState({error: "Please set the pickup date"});
    let pickupTimeParam;
    if( !pickupTime && state.shipmentInfo.isStartHandoff &&
        state.shipmentInfo.shipmentType !=2 ){
      pickupTimeParam = moment(state.shipmentInfo.actualPickUpTime).unix()*1000;
    }
    else if(!pickupTime && state.shipmentInfo.pickupDateTime){
      pickupTimeParam = moment(state.shipmentInfo.pickupDateTime).unix()*1000;
    }
    else pickupTimeParam = pickupTime;


    const paramObj = {
      shipmentId: shipmentId,
      isPickup: true,
      dateTime: pickupTimeParam
    };

    // paramObj.dateTime = localTimestampToGMT(paramObj.dateTime);
    this.setState({isLoading:true});

    props.shipmentActions.addEditPickUpDeliveryTime(paramObj).then(() => {
      self.setState({isLoading: false, error: '',editPickupTime: '',disbleBtn: false},props.updateErrorState(''));
      if(deliveryTime){
        self.setDeliveryDate();
      }
    }, (errorRes) => {
      self.setState({isLoading: false, error: errorRes.error})
      props.updateErrorState(errorRes.error);
      $("html, body").animate({scrollTop: 0}, 1000);
    });
  }

  onDeliveryDateChange = (deliveryDate) => {
    const date = deliveryDate;
    const deliveryTime = deliveryDate.unix()*1000;
    this.setState({
      deliveryDate: date,
      deliveryTime,
      disbleBtn: false
    });
  }

  componentWillReceiveProps(newProps){
    this.setState({
      shipment: newProps.shipmentStatusData,
      shipmentInfo: newProps.shipmentInfo,
      carrierId: newProps.carrierId
    });
  }

  valid = (current) => {
    return current.diff(moment().subtract(2,'day') , 'days') > 0 &&  current.diff(moment().startOf('day') , 'days') < 7;
  };

  disablePrevDates = (current) => {
    return current.isAfter( yesterday );
  };

  validDeliveryDate = (current) => {
    const {state} = this;

    let pickupDate;
    if(state.pickupTime){
      // let gmtLocal = GMTTimeStampToLocal(state.pickupDate);
      pickupDate = moment(state.pickupDate).format('lll');
    }
    else if(state.shipment.isStartHandoff && shipment.shipmentType !=2){
      // let gmtLocal = GMTTimeStampToLocal(state.shipment.actualPickUpTime);
      pickupDate = moment(state.shipment.actualPickUpTime).format('lll');
    }
    else if(state.shipment.pickupDateTime){
      // let gmtLocal = GMTTimeStampToLocal(state.shipment.pickupDateTime);
      pickupDate = moment(state.shipment.pickupDateTime).format('lll');
    }
    else pickupDate = "";

    return pickupDate && current.isAfter(pickupDate);
  }

  onEditDelivery = () => {
    this.setState({editDeliveryTime: true})
  }

  onEditPickup = () => {
    this.setState({editPickupTime: true})
  }

  componentDidMount(){
    const {props} = this;

    if( validate.isEmpty(props.carrierId) ||
        validate.isEmpty(props.shipmentStatusData)||
        validate.isEmpty(props.shipmentInfo)
     ){
       browserHistory.push("/inbox");
     }
  }

  onEditDate = () => {
    this.setState({editPickupTime: true, editDeliveryTime: true});
  }

  render(){
    const self = this;
    const {state,props} = this;
    const {shipment,shipmentInfo} = state;

    let inputClassName;
    if(shipment.deliveryDateTime && !state.editDeliveryTime) inputClassName = "edit-date-ip";
    else if(state.editDeliveryTime) inputClassName = "date-input";
    else inputClassName = "date-input";

    let deliveryDate;
    if(shipmentInfo.deliveryDateTime ) deliveryDate = moment(shipmentInfo.deliveryDateTime).format('lll');
    else if(shipment.deliveryDateTime ) deliveryDate = moment(shipment.deliveryDateTime).format('lll');
    else deliveryDate = "";

    let pickupDate;
    if(state.shipment.isStartHandoff && shipment.shipmentType !=2){
      // let gmtLocal = GMTTimeStampToLocal(state.shipment.actualPickUpTime);
      pickupDate = moment(state.shipment.actualPickUpTime).format('lll');
    }
    else if(state.shipment.pickupDateTime){
      // let gmtLocal = GMTTimeStampToLocal(state.shipment.pickupDateTime);
      pickupDate = moment(state.shipment.pickupDateTime).format('lll');
    }
    else pickupDate = "";

    let timeStaticInfo;
    if( shipment.isOfferAccepted &&
        shipmentInfo.shipmentType !=2 &&
        !shipmentInfo.isStartHandoff &&
        !pickupDate &&
        !deliveryDate &&
        shipment.isShipper){
        timeStaticInfo = "Establish a date & time for pickup and delivery. Once you’ve both agreed, you can add the date & time below. Package must be delivered within 7 days of pickup.";
    }
    else if(!shipment.isOfferAccepted && shipment.isShipper){
        timeStaticInfo = "If you don't respond within 48 hours we will automatically decline this offer.";
    }

    let pickupInputClassName;
    if(state.editPickupTime && shipmentInfo.isShipper) pickupInputClassName = "date-input";
    else if(pickupDate) pickupInputClassName = "edit-date-ip";
    else pickupInputClassName = "date-input";

    let deliveryInputClassName;
    if(state.editDeliveryTime && shipmentInfo.isShipper) deliveryInputClassName = "date-input";
    else if(deliveryDate) deliveryInputClassName = "edit-date-ip";
    else deliveryInputClassName = "date-input";

    //Edit deliveryTime COndition
    let isEditDeliveryDateTime = false,
        isEditPickupDateTime = false;

    //Edit pickupDate
    if( shipment.shipmentStatus==4 &&
    shipment.isShipper &&
    shipment.shipmentType !=2 &&
    !state.editPickupTime &&
    pickupDate){
      isEditPickupDateTime = true
    }

    //Edit DeliveryDate
    if( shipment.shipmentStatus==4 &&
    shipment.isShipper &&
    !state.editDeliveryTime&&
    deliveryDate ){
      isEditDeliveryDateTime = true
    }

    return(
      <div className = "pickup-and-delivery-time-section">
        {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        {
          timeStaticInfo && <p className = "time-info">{timeStaticInfo}</p>
        }
        {
          !shipment.isOfferAccepted && shipment.isOfferMade && shipment.isShipper &&
          <div className = "shipment-action-btn-wrp">
            <div className = "time-btn-wrap">
              <button className = "btn action-btn decline-offer" onClick = {self.acceptOrDeclineOffer.bind(self,false)}>Decline</button>
            </div>
            <div className = "time-btn-wrap">
              <button className = "btn action-btn orange accept-offer" onClick = {self.acceptOrDeclineOffer.bind(self,true)}>Accept</button>
            </div>
          </div>
        }
        {
          shipment.isOfferAccepted &&
          <div className = "date-input-picker-wrap">
            <div className = "pickup-date-wrapper">
              {
                state.shipment.shipmentType !=2 && pickupDate &&
                <div className = "pickup-delivery-date-wrap">
                    <div className = "date-wrap">
                      <span className = "icon-calendar calendar-img"></span>
                      <span className = "date">Pick up on</span>
                    </div>
                </div>
              }
              {
                //To set pickup date it does not have all custom classnames
                (shipment.shipmentType !=2 && !pickupDate && shipment.isShipper)&&
                <DateTimePicker
                  onBlur = {this.onBlur}
                  onChange = {this.onPickupDateChange}
                  open = {false}
                  isValidDate = {this.valid}
                  className = "date-time-picker"
                  closeOnTab = {true}
                  closeOnSelect = {true}
                  inputProps = {
                    {
                        placeholder: "Set pickup time",
                        className: "date-input"
                      }
                    }
                  />
                }
              {
                //To show pickupDate and edit
                shipment.shipmentType !=2 && pickupDate &&

                <DateTimePicker
                  onBlur = {this.onBlur}
                  onChange = {this.onPickupDateChange}
                  open = {false}
                  isValidDate = {this.valid}
                  className = {isEditPickupDateTime ? "date-time-picker" : "disable-date-picker"}
                  closeOnTab = {true}
                  closeOnSelect = {true}
                  defaultValue = {pickupDate}
                  inputProps = {
                    {
                        placeholder: "Set pickup time",
                        className: pickupInputClassName
                      }
                    }
                  />
                }
                {
                  isEditPickupDateTime &&
                  <span className = "icon-pencil edit-icn edit-pickup" onClick = {this.onEditPickup}></span>
                }
              </div>
              <div className = "delivery-date-wrapper">
                {
                  deliveryDate &&
                  <div className = "pickup-delivery-date-wrap">
                    <div className = "delivery-date">
                     <span className = "icon-calendar calendar-img"></span>
                      <span className = "date">Delivery on</span>
                    </div>
                  </div>
                }
                {/*To add delivery date time[show only when pickup is set*/}
                {
                  !deliveryDate && shipment.isShipper && (state.pickupTime || pickupDate || shipment.shipmentType ===2) &&
                  <DateTimePicker
                  onBlur = {this.onBlur}
                  onChange = {this.onDeliveryDateChange}
                  open = {false}
                  className = "date-time-picker"
                  closeOnTab = {true}
                  closeOnSelect = {true}
                  disabled = {true}
                  isValidDate = {pickupDate ? this.validDeliveryDate : this.valid}
                  inputProps = {
                    {
                      placeholder: "Set Delivery time",
                      className: "date-input"
                    }
                  }/>
                }
                {
                  //to show and edit delivery date time
                  deliveryDate && <DateTimePicker
                  onBlur = {this.onBlur}
                  onChange = {this.onDeliveryDateChange}
                  open = {false}
                  className = {isEditDeliveryDateTime ? "date-time-picker" : "disable-date-picker"}
                  closeOnTab = {true}
                  closeOnSelect = {true}
                  disabled = {true}
                  isValidDate = {!state.editDeliveryTime ? this.valid : this.validDeliveryDate}
                  defaultValue = {deliveryDate}
                  inputProps = {
                    {
                      placeholder: "Set Delivery time",
                      className: deliveryInputClassName
                    }
                  }
                />
              }
              {
                //Edit delivery time
                isEditDeliveryDateTime &&
                <span className = "icon-pencil edit-icn edit-pickup" onClick = {this.onEditPickup}></span>
              }
            </div>
              {
                ((shipment.shipmentStatus==4) && shipment.isShipper )&&
                <div className = "time-btn-wrap">
                  <button className = {classNames("btn action-btn orange save-btn", {"disabled":state.disbleBtn})}
                      onClick = {self.addEditPickUpDeliveryTime}>Save
                  </button>
                </div>
              }
            </div>
        }
      </div>
    );
  }
}

SetPickupAndDeliveyTime = connect((state) => {
  return {
    authState : state.app.auth
  }
}, (dispatch) => {
  return {
    shipmentActions: bindActionCreators(shipmentActions, dispatch)
  }
})(SetPickupAndDeliveyTime);

module.exports = SetPickupAndDeliveyTime;



// WEBPACK FOOTER //
// app/messages/pickup_delivery.jsx